/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  DutyRosterReleaseWorkflowDto,
  GetDutyRosterReleaseWorkflowsParams
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetDutyRosterReleaseWorkflowsUrl = (params?: GetDutyRosterReleaseWorkflowsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DutyRosterReleaseWorkflow/GetDutyRosterReleaseWorkflows?${stringifiedParams}` : `/api/DutyRosterReleaseWorkflow/GetDutyRosterReleaseWorkflows`
}

export const getDutyRosterReleaseWorkflows = async (params?: GetDutyRosterReleaseWorkflowsParams, options?: Parameters<typeof customInstance>[1]): Promise<DutyRosterReleaseWorkflowDto[]> => {

  return customInstance<DutyRosterReleaseWorkflowDto[]>(getGetDutyRosterReleaseWorkflowsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDutyRosterReleaseWorkflowsQueryKey = (params?: GetDutyRosterReleaseWorkflowsParams,) => {
    return [
    `/api/DutyRosterReleaseWorkflow/GetDutyRosterReleaseWorkflows`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDutyRosterReleaseWorkflowsQueryOptions = <TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDutyRosterReleaseWorkflowsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>> = ({ signal }) => getDutyRosterReleaseWorkflows(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDutyRosterReleaseWorkflowsQueryResult = NonNullable<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>>
export type GetDutyRosterReleaseWorkflowsQueryError = ErrorType<unknown>


export function useGetDutyRosterReleaseWorkflows<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDutyRosterReleaseWorkflowsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDutyRosterReleaseWorkflows<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>,
          TError,
          Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDutyRosterReleaseWorkflows<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDutyRosterReleaseWorkflows<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDutyRosterReleaseWorkflowsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDutyRosterReleaseWorkflowsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDutyRosterReleaseWorkflowsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>> = ({ signal }) => getDutyRosterReleaseWorkflows(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDutyRosterReleaseWorkflowsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>>
export type GetDutyRosterReleaseWorkflowsSuspenseQueryError = ErrorType<unknown>


export function useGetDutyRosterReleaseWorkflowsSuspense<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDutyRosterReleaseWorkflowsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDutyRosterReleaseWorkflowsSuspense<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDutyRosterReleaseWorkflowsSuspense<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDutyRosterReleaseWorkflowsSuspense<TData = Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError = ErrorType<unknown>>(
 params?: GetDutyRosterReleaseWorkflowsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDutyRosterReleaseWorkflows>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDutyRosterReleaseWorkflowsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






